import Reveal from "@/components/Reveal";
import { FilePlus2, ScanLine, GitCompare, SlidersHorizontal, FileCheck2, ShieldCheck } from "lucide-react";

const features = [
  {
    icon: ScanLine,
    title: "ADAC Validation",
    desc: "Validate any ADAC XML against the schema and your acceptance rules. Get clear, line-level feedback you can act on.",
    snippet: "✓ 1,284 nodes · ⚠ 3 warnings · ✗ 1 error",
    span: "lg:col-span-2",
  },
  {
    icon: FilePlus2,
    title: "ADAC XML Creation",
    desc: "Build compliant ADAC XML with structure and mandatory fields enforced as you go.",
    snippet: "<adac:Survey> generated",
    span: "",
  },
  {
    icon: GitCompare,
    title: "Comparison",
    desc: "Diff two submissions — original vs resubmission — and see exactly what changed.",
    snippet: "Δ 42 nodes changed",
    span: "",
  },
  {
    icon: SlidersHorizontal,
    title: "Profiling",
    desc: "Profile data quality and continuity across a dataset before it ever reaches a reviewer.",
    snippet: "Quality score 98.4%",
    span: "lg:col-span-2",
  },
  {
    icon: ShieldCheck,
    title: "Acceptance Standard",
    desc: "Encode one consistent QA standard and apply it to every submission, every project.",
    snippet: "standard: council-v5.2",
    span: "",
  },
  {
    icon: FileCheck2,
    title: "Audit-ready Reports",
    desc: "Export shareable validation reports for a clean, defensible handover trail.",
    snippet: "report.pdf · report.xml",
    span: "",
  },
];

export default function Features() {
  return (
    <section data-testid="features-section" id="features" className="py-24 md:py-32 bg-white border-y border-zinc-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal className="max-w-3xl mb-14">
          <p className="text-xs font-semibold tracking-[0.2em] uppercase text-[#0033A0] font-mono">Capabilities</p>
          <h2 className="mt-4 font-heading text-3xl sm:text-4xl font-medium tracking-tight text-zinc-900 leading-tight">
            Everything the ADAC lifecycle needs, in one platform.
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((f, i) => (
            <Reveal
              key={f.title}
              delay={(i % 3) * 0.06}
              hoverLift
              className={`group rounded-2xl border border-zinc-200 bg-[#F9F9F8] p-8 hover:border-zinc-400 hover:shadow-lg transition-[box-shadow,border-color] duration-300 ${f.span}`}
            >
              <span className="h-11 w-11 grid place-items-center bg-[#E6EBF5] text-[#0033A0] rounded-sm">
                <f.icon size={22} strokeWidth={1.6} />
              </span>
              <h3 className="mt-5 font-heading text-xl font-medium text-zinc-900">{f.title}</h3>
              <p className="mt-2 text-sm text-zinc-600 leading-relaxed">{f.desc}</p>
              <p className="mt-5 inline-block font-mono text-xs text-zinc-500 bg-white border border-zinc-200 rounded px-3 py-1.5">
                {f.snippet}
              </p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
